export const ACTIVE_FLOODING_SOURCE_ID = 'flooding-events-active';
export const INACTIVE_FLOODING_SOURCE_ID = 'flooding-events-inactive';

export const ACTIVE_FLOODING_ICONS_LAYER_ID = 'flooding-event-active-icons';
export const ACTIVE_FLOODING_LABELS_LAYER_ID = 'flooding-event-active-labels';
export const INACTIVE_FLOODING_ICONS_LAYER_ID = 'flooding-event-inactive-icons';
export const INACTIVE_FLOODING_LABELS_LAYER_ID =
  'flooding-event-inactive-labels';

export const FLOODING_ACTIVE_LABELS_MIN_ZOOM = 7;
export const FLOODING_INACTIVE_LABELS_MIN_ZOOM = 9;
export const ONE_YEAR_MS = 31560000000;
